export default __webpack_public_path__ + "static/media/PolyBetTOS.47586503.pdf";